// src/components/layout/RoleProtectedRoute.jsx
import React from 'react';
import { Navigate, useOutletContext } from 'react-router-dom';
import styles from './RoleProtectedRoute.module.css';

const RoleProtectedRoute = ({ children, allowedRoles }) => {
  // Always call hooks at the top level
  const context = useOutletContext();
  const { user } = context || {};

  console.log('🔐 RoleProtectedRoute - User:', user);
  console.log('🔐 RoleProtectedRoute - Allowed roles:', allowedRoles);
  console.log('🔐 RoleProtectedRoute - User roleId:', user?.roleId);

  // RequireUser already ensures user exists, but adding safety check
  // If somehow no user (shouldn't happen), just render children
  if (!user) {
    console.warn('⚠️ RoleProtectedRoute: No user found (RequireUser should prevent this)');
    return children; // Let RequireUser handle the loading state
  }

  // Check if user's role is in the allowed roles
  if (allowedRoles && !allowedRoles.includes(user.roleId)) {
    console.log('❌ Access denied - User role not in allowed roles');
    return (
      <div className={styles.unauthorizedContainer}>
        <div className={styles.icon}>🚫</div>
        <h1 className={styles.title}>Access Denied</h1>
        <p className={styles.message}>
          You don't have permission to access this page. 
          Please contact your administrator if you believe this is an error.
        </p>
        <button 
          className={styles.backButton}
          onClick={() => window.history.back()}
        >
          Go Back
        </button>
      </div>
    );
  }

  console.log('✅ Access granted');
  return children;
};

export default RoleProtectedRoute;